import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { LocalStorageService } from '../../shared/services/local-storage/localstorage.service';
import { authService } from '../../shared/services/auth/auth.service';

export const authGuard: CanActivateFn = async (route) => {
  const localStorageService = inject(LocalStorageService);
  const authServices = inject(authService);
  const router = inject(Router);
  const userPref: any = localStorageService.getItem('userPreferences');
  const isAuthenticated = (!!userPref && userPref?.selectedCompanyId != 0 && userPref?.selectedProjectId != 0);

  const isTokenValidOrNot = await authServices.checkTokenAndRefresh();

  // If authenticated but the current JWT is missing companyId (issued before the
  // Cognito Lambda trigger was wired up), force one refresh so the node backend
  // session gets the correct claim on the next request.
  // Session flag prevents this from firing on every route activation.
  // if (isAuthenticated && isTokenValidOrNot && !sessionStorage.getItem('col44_claim_checked')) {
  //   sessionStorage.setItem('col44_claim_checked', '1');
  //   const token = authServices.getCurrentAccessToken();
  //   if (token) {
  //     try {
  //       const claims = JSON.parse(atob(token.split('.')[1]));
  //       if (!claims.companyId && !claims['custom:companyId']) {
  //         const tokens = authServices.getTokenFromStorage();
  //         if (tokens?.refresh_token) {
  //           const fresh = await authServices.getTokens(tokens.refresh_token, 'refresh_token');
  //           authServices.storeTokens({ ...fresh, refresh_token: tokens.refresh_token });
  //         }
  //       }
  //     } catch {
  //       // Non-fatal — malformed token handled by backend
  //     }
  //   }
  // }

  if (route.routeConfig.path == 'auth') {
    if (isAuthenticated && isTokenValidOrNot) {
      router.navigate(['/dashboard'], { replaceUrl: true });
      return false;
    }
    return true;
  } else if (route.routeConfig.path == 'company-selection') {
    if (!isAuthenticated && !isTokenValidOrNot) {
      return false;
    }
    return true;
  } else {
    if (isAuthenticated && isTokenValidOrNot) {
      return true;
    } else {
      router.navigate(['/auth']);
      return false;
    }
  }
};
